import HPButton from "./Button";
import React, { useState } from "react";
import Tooltip from "@components/common/Tooltip";

interface HPSelectModalProps {
  onClose: () => void;
  title: React.ReactNode;
  items: { id: string; name: string }[];
  onAdd: (selectedId: string) => void;
  addButtonText?: string;
}

const HPSelectModal: React.FC<HPSelectModalProps> = ({
  onClose,
  title,
  items,
  onAdd,
  addButtonText = "Add Surveys",
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);


  return (
    <div
      className={`bg-white rounded-lg shadow-lg flex flex-col w-[600px] mx-auto`}
    >
      <div className="p-6 flex gap-1">
        <h2 className="text-lg font-semibold">{title}</h2>
      </div>
      <div className="text-sm border-t border-b border-hp-border-default">
        <div className="p-6 flex flex-col gap-2">
          <ul className="max-h-96 overflow-y-auto ">
            {items.map((item) => (
              <li
                key={item.id}
                className={`cursor-pointer px-4 py-2 ${selectedId === item.id ? "bg-hp-selected-background text-hp-primary" : ""} `}
                onClick={() => setSelectedId(item.id)}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="flex justify-end gap-1 p-4">
        <HPButton
          ariaLabel="Cancel"
          variant="text"
          size="medium"
          color="primary"
          onClick={() => {
            setSelectedId(null);
            onClose();
          }}
          className="text-hp-text-day-primary"
        >
          Cancel
        </HPButton>
        <Tooltip
          title={!selectedId ? "First select dataset to add surveys" : ""}
          placement="top"
          arrow
        >
          <span>
            <HPButton
              ariaLabel={addButtonText}
              variant="contained"
              size="medium"
              color="primary"
              onClick={() => {
                if (selectedId) {
                  onAdd(selectedId);
                  setSelectedId(null);
                }
              }}
              disabled={!selectedId}
            >
              {addButtonText}
            </HPButton>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default HPSelectModal;
